import axios from '../axios.js';

var api = {
  //题库列表
  getTopic(params){
    return axios.post('index/topic/index',params)
  },
  //题目详情
  getTopicInfos(params){
    return axios.post('index/topic/detail',params)
  },
  //题目搜索
  searchTopic(params){
    return axios.post('index/topic/searchTopic',params)
  },
  //收藏题目
  joinCollect(params){
    return axios.post('index/topic/joinCollect',params)
  },
  //取消收藏题目
  outCollect(params){
    return axios.post('index/topic/outCollect',params)
  }
}

export default api



// WEBPACK FOOTER //
// ./src/api/subject.js